export const UTColors = {
  primary: 'var(--color-ut-primary, #3187ee)',
  primaryUp: 'var(--color-ut-primary-up, #52A0FF)',
  primaryDown: 'var(--color-ut-primary-down, #126BD9)',

  primaryDim: 'var(--color-ut-primary-dim, rgba(49, 135, 238, 0.1))',
  primaryDimUp: 'var(--color-ut-primary-dim-up, rgba(49, 135, 238, 0.2))',
  primaryDimDown: 'var(--color-ut-primary-dim-down,rgba(49, 135, 238, 0.3))',
  primaryDimFocus: 'var(--color-ut-primary-dim-focus, rgba(49, 134, 238, 0.4))',

  warning: 'var(--color-ut-warning, #FFDF5A)',
  warningUp: 'var(--color-ut-warning-up, #FFD527)',
  warningDown: 'var(--color-ut-warning-down, #F8C800)',

  warningDim: 'var(--color-ut-warning-dim, rgba(255, 223, 90, 0.3))',
  warningDimUp: 'var(--color-ut-warning-dim-up, rgba(255, 223, 90, 0.5))',
  warningDimDown: 'var(--color-ut-warning-dim-down, rgba(255, 223, 90, 0.8))',

  alert: 'var(--color-ut-alert, #ed4040)',
  alertUp: 'var(--color-ut-alert-up, #FF5252)',
  alertDown: 'var(--color-ut-alert-down, #DE3131)',

  alertDim: 'var(--color-ut-alert-dim, rgba(237, 64, 64, 0.1))',
  alertDimUp: 'var(--color-ut-alert-dim-up, rgba(237, 64, 64, 0.15))',
  alertDimDown: 'var(--color-ut-alert-dim-down, rgba(237, 64, 64, 0.3))',
  alertDimFocus: 'var(--color-ut-alert-dim-focus, rgba(237, 64, 64, 0.2))',

  error: 'var(--color-ut-error, #ff9113)',
  errorUp: 'var(--color-ut-error-up, #FFA238)',
  errorDown: 'var(--color-ut-error-down, #EB8709)',

  errorDim: 'var(--color-ut-error-dim, rgba(255, 145, 19, 0.15))',
  errorDimUp: 'var(--color-ut-error-dim-up, rgba(255, 145, 19, 0.22))',
  errorDimDown: 'var(--color-ut-error-dim-down, rgba(255, 145, 19, 0.35))',

  success: 'var(--color-ut-success, #33B327)',
  successUp: 'var(--color-ut-success-up,  #42C936)',
  successDown: 'var(--color-ut-success-down,  #29A81D)',

  successDim: 'var(--color-ut-success-dim, rgba(51, 179, 39, 0.1))',
  successDimUp: 'var(--color-ut-success-dim-up, rgba(51, 179, 39, 0.2))',
  successDimDown: 'var(--color-ut-success-dim-down, rgba(51, 179, 39, 0.3))',
  successDimFocus: 'var(--color-ut-success-dim-focus, rgba(51, 178, 39, 0.4))',

  muted: 'var(--color-ut-muted, #3a3a3c)',
  mutedUp: 'var(--color-ut-muted-up, #535356)',
  mutedDown: 'var(--color-ut-muted-down, #262628)',

  input: 'var(--color-ut-input, rgba(0, 41, 91, 0.06))',
  inputUp: 'var(--color-ut-input-up, rgba(0, 41, 91, 0.09))',
  inputDown: 'var(--color-ut-input-down, rgba(0, 41, 91, 0.12))',
  inputFocus: 'var(--color-ut-input-focus, rgba(0, 41, 91, 0.2))',

  scream: 'var(--color-ut-scream, #004BFF)',
  screamUp: 'var(--color-ut-scream-up, #327DFF)',
  screamDown: 'var(--color-ut-scream-down, #002DE1)',

  screamDim: 'var(--color-ut-scream-dim, rgba(0, 75, 255, 0.1))',
  screamDimUp: 'var(--color-ut-scream-dim-up, rgba(0, 75, 255, 0.2))',
  screamDimDown: 'var(--color-ut-scream-dim-down, rgba(0, 75, 255, 0.3))',
  screamDimFocus: 'var(--color-ut-scream-dim-focus, rgba(0, 75, 255, 0.4))',

  disabled: 'var(--color-ut-disabled, rgba(0, 0, 0, 0.04))',

  inputRegular: 'var(--color-ut-input-regular,  rgba(0, 41, 91, 0.06))',
  inputActive: 'var(--color-ut-input-active, rgba(0, 41, 91, 0.1))',

  border30: 'var(--color-ut-border30, rgba(0, 0, 0, 0.3))',
  border15: 'var(--color-ut-border15, rgba(0, 0, 0, 0.15))',
  border10: 'var(--color-ut-border10, rgba(0, 0, 0, 0.1))',
  border5: 'var(--color-ut-border5, rgba(0, 0, 0, 0.05))',

  shadow10: 'var(--color-ut-shadow10, rgba(0, 0, 0, 0.1))',

  bgDefault: 'var(--color-ut-bg-default, #FFFFFF)',
  bgDefault10: 'var(--color-ut-bg-default10, rgba(255, 255, 255, 0.1))',
  bgDim: 'var(--color-ut-bg-dim, #F2F4F6)',
  bgUp: 'var(--color-ut-bg-up, #FFFFFF)',

  listItemUp: 'var(--color-ut-list-item-up, rgba(255, 255, 255, 0.05))',
  listItemDown: 'var(--color-ut-list-item-down, rgba(0, 0, 0, 0.1))',
  popupShadow: 'var(--color-ut-popup-shadow, rgba(0, 0, 0, 0.1))',

  modalOverlay: 'var(--color-ut-modal-overly, rgba(0, 0, 20, 0.4))'
};

export const TXTColors = {
  default: 'var(--color-text-default, #000000)',
  defaultDim: 'var(--color-text-default-dim, rgba(0, 0, 0, 0.5))',
  disabled: 'var(--color-text-disabled, rgba(0, 0, 0, 0.3))',
  inverse: 'var(--color-text-inverse, #ffffff)',
  inverseDim: 'var(--color-text-inverse-dim, rgba(255, 255, 255, 0.5))',
  primary: 'var(--color-text-primary, #0b5acd)',
  primaryInverse: 'var(--color-text-primary-inverse, #52A0FF)',
  success: 'var(--color-text-success, #02980e)',
  alert: 'var(--color-text-alert, #d41919)',
  alertDim: 'var(--color-text-alert-dim, rgba(212, 25, 25, 0.2))',
  error: 'var(--color-text-error,  #e47a00)',
  warning: 'var(--color-text-warning, #65290D)',
  buttonDefault: 'var(--color-text-button-default, #ffffff)',
  buttonInverse: 'var(--color-text-button-inverse, #000000)'
};

export const GraphColors = {
  up: 'var(--color-graph-up, #5495D8)',
  upDim: 'var(--color-graph-up-dim, rgba(80, 134, 200, 0.15))',
  down: 'var(--color-graph-down, #E68282)',
  downDim: 'var(--color-graph-down-dim, rgba(180, 86, 83, 0.1))'
};
